import { render, staticRenderFns } from "./TabelHeaderForNewOrder.vue?vue&type=template&id=af8d61a2&"
import script from "./TabelHeaderForNewOrder.vue?vue&type=script&lang=js&"
export * from "./TabelHeaderForNewOrder.vue?vue&type=script&lang=js&"
import style0 from "./TabelHeaderForNewOrder.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("D:\\JG\\jg\\IWMS5.0\\SRM\\GIT\\SRM.VUE\\node_modules\\vue-hot-reload-api\\dist\\index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('af8d61a2')) {
      api.createRecord('af8d61a2', component.options)
    } else {
      api.reload('af8d61a2', component.options)
    }
    module.hot.accept("./TabelHeaderForNewOrder.vue?vue&type=template&id=af8d61a2&", function () {
      api.rerender('af8d61a2', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/DeliveryNote/SubDeliveryNote/components/TabelHeaderForNewOrder.vue"
export default component.exports